import React from "react";
import { statusMap } from "./constants";

export default function PositionInfo({ position, createdAt }) {
  return (
    <div className="d-flex mb-3">
      <img
        src={position.image}
        alt={position.article}
        style={{ width: 130, height: 130, objectFit: "contain" }}
        className="rounded border me-3"
      />

      <div>
        <h5>{position.name}</h5>
        <div className="text-muted">Артикул: {position.article}</div>
        <div className="text-muted">Время заказа: {createdAt}</div>
        <div className="mt-2">
          Текущий статус: <strong>{statusMap[position.status] || position.status}</strong>
        </div>
      </div>
    </div>
  );
}